// extracted by mini-css-extract-plugin
module.exports = {"percent":"oddStatistic__percent___2lKpG","exist":"oddStatistic__exist___3UFi6","not-exist":"oddStatistic__not-exist___1gdgn"};